import useAnalytics from "@/hooks/useAnalytics";
import useTranslation from "@/hooks/useTranslation";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Popconfirm, message } from "antd";
import { ReactNode } from "react";
import { useBulkDeleteProxy } from "../../useProducts";

export default function DeleteProxyAction({
  proxyIds,
  children,
  onSuccess,
  disabled,
}: {
  proxyIds: number[];
  children: ReactNode;
  onSuccess?: () => void;
  disabled?: boolean;
}) {
  const bulkDelete = useBulkDeleteProxy();
  const translation = useTranslation();
  const analytics = useAnalytics();

  const onDelete = async () => {
    return bulkDelete
      .mutateAsync({
        productIds: proxyIds,
      })
      .catch(() => {
        message.error(translation.errors.general);
      })
      .then(() => {
        analytics.track(proxyIds.length === 1 ? `Proxy Deleted` : `Proxies Deleted`);
        message.success(
          proxyIds.length === 1 ? `Proxy relation deleted.` : `Proxy relations deleted.`
        );
        onSuccess?.();
      });
  };

  const productText = proxyIds.length === 1 ? "proxy" : `${proxyIds.length} proxies`;

  return (
    <Popconfirm
      title={`Delete ${productText}`}
      description={
        <>
          <p>Deleting a proxy means that this product will no longer be connected to its source.</p>
        </>
      }
      onConfirm={onDelete}
      onCancel={() => {}}
      icon={<ExclamationCircleFilled style={{ color: "#F5222D" }} />}
      okText={`Delete ${productText}`}
      cancelText="Cancel"
      placement="top"
      overlayStyle={{ width: "400px" }}
      okType="danger"
      okButtonProps={{ loading: bulkDelete.isLoading }}
      disabled={disabled}
    >
      {children}
    </Popconfirm>
  );
}
